// Module
var code = "<a class=\"PhoneSupport\" href=\"tel:{{ SupportPhone.number }}\" data-hook=\"phone-support\" ng-click=\"SupportPhone.analyticsTrack()\"> {{SupportPhone.number}} </a> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/supportPhone/supportPhone.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;